// removed by extract-text-webpack-plugin
module.exports = {"pageSection":"_1W43q","gridContainer":"X0G8v","borderTop":"_28J6n","darkBackground":"_10fKv","spaceBottom":"_3D5-B"};